export { default as Taxes } from './Taxes'
export { default as Tax } from './Tax'



// WEBPACK FOOTER //
// ./scripts/components/views/membership/taxes/index.js